import type { OnboardingRole, TeamSize } from '@reelplicate/api-client/model';

import type { ROLES, TEAM_SIZES } from './schemas';

type Role = (typeof ROLES)[number];
type Size = (typeof TEAM_SIZES)[number];

/** Step 1's form values ↔ the API's enums. */
export const ROLE_TO_API: Record<Role, OnboardingRole> = {
  founder: 'FOUNDER',
  marketer: 'MARKETER',
  agency: 'AGENCY',
  creator: 'CREATOR',
};

export const TEAM_SIZE_TO_API: Record<Size, TeamSize> = {
  '1': 'SOLO',
  '2-5': 'TWO_TO_FIVE',
  '6-20': 'SIX_TO_TWENTY',
  '21-50': 'TWENTY_ONE_TO_FIFTY',
  '50+': 'FIFTY_PLUS',
};

const invert = <K extends string, V extends string>(map: Record<K, V>) =>
  Object.fromEntries(Object.entries(map).map(([k, v]) => [v, k])) as Record<V, K>;

export const ROLE_FROM_API = invert(ROLE_TO_API);
export const TEAM_SIZE_FROM_API = invert(TEAM_SIZE_TO_API);

/** "https://oatandember.com" → "oatandember.com". */
export const siteHost = (url: string | null | undefined) =>
  url ? url.replace(/^https?:\/\//, '').replace(/\/.*$/, '') : '';
